import { roundNumberToNearestCent } from '@ami/react/core';

export const OverallDiscountType = Object.freeze({
  Percentage: 'Percentage',
  FixedAmount: 'Fixed amount',
});

export default class OverallDiscount {
  constructor(json) {
    if (json) {
      this.name = json.name;
      this.value = json.value;
      this.type = json.type;
      return;
    }
    this.name = '';
    this.value = 0;
    this.type = 'Percentage';
  }

  static fromServerEntity(json) {
    return Object.assign(new OverallDiscount(json));
  }

  getDiscountAmount(subTotal) {
    if (this.type === 'FixedAmount') {
      return parseFloat(this.value);
    } else {
      return roundNumberToNearestCent((subTotal * this.value) / 100);
    }
  }
}
